import { Color, Spacing } from '@persona-id/design-tokens';
import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import { isEmpty } from 'lodash';
import { VFC } from 'react';
import styled from 'styled-components';

import Banner from 'dashboard/components-lib/Banner';
import { SARStatus } from 'dashboard/models/sar';

const ListContainer = styled.div`
  margin: 0 ${Spacing[4]};
`;

const StyledBanner = styled(Banner)`
  padding-top: ${Spacing[2]};
  padding-bottom: ${Spacing[2]};
`;

interface SARErrorMessagesBannerProps {
  status: SARStatus;
  errorMessages: Record<string, string>;
}

export const SARErrorMessagesBanner: VFC<SARErrorMessagesBannerProps> = ({
  status,
  errorMessages,
}) => {
  if (isEmpty(errorMessages)) {
    return null;
  }

  const isRejected = status === SARStatus.Rejected;

  return (
    <StyledBanner
      backgroundColor={isRejected ? Color.CoreRed100 : Color.CoreYellow100}
      icon={<CircleAlertIcon />}
    >
      {errorMessages['summary']}
      <a
        href={
          isRejected
            ? 'https://help.withpersona.com/articles/5OgsYAO6qfIXQVsXy4BzLg/#fixing-a-rejected-sar'
            : 'https://help.withpersona.com/articles/5OgsYAO6qfIXQVsXy4BzLg/#correcting-or-amending-a-sar'
        }
        target='_blank'
        rel='noreferrer'
      >
        &nbsp; Learn more
      </a>
      {/* <Spacer height={1} /> */}

      <ListContainer>
        <ul>
          {Object.entries(errorMessages).map(([field, errorMessage]) => {
            if (field === 'summary') return null;
            return (
              <li key={field}>
                {field}: {errorMessage}
              </li>
            );
          })}
        </ul>
      </ListContainer>
    </StyledBanner>
  );
};
